// Student profili: bo'sh maydonlar va to'ldirilganlik darajasi.
// Bo'sh qiymatlar (docs/api/kursga-yozilmagan-userlar-api.md, 3-bo'lim): null va "" → "—".

export const EMPTY = '—';

export const isFilled = (value) => {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') return value.trim() !== '';
  if (Array.isArray(value)) return value.length > 0;
  return true;
};

export const displayValue = (value) => (isFilled(value) ? value : EMPTY);

// Ro'yxatdan o'tgandan keyin student o'zi to'ldiradigan maydonlar.
// Ism-familiya (ro'yxatdan o'tishda majburiy) va aloqa (telefon/email — ro'yxatdan o'tish usuli) sanalmaydi.
export const PROFILE_FIELDS = [
  'middle_name',
  'birthdate',
  'citizenship',
  'living_country',
  'living_city',
  'living_address',
  'postal_code',
  'edu_level',
  'photo',
  'identity_card',
  'edu_doc',
];

export const PROFILE_STATUS = {
  empty: { label: "To'ldirilmagan", variant: 'neutral' },
  partial: { label: 'Qisman', variant: 'warning' },
  full: { label: "To'liq", variant: 'success' },
};

// { filled, total, status: 'empty' | 'partial' | 'full' }
export function profileCompleteness(user) {
  const total = PROFILE_FIELDS.length;
  const filled = PROFILE_FIELDS.filter((field) => isFilled(user?.[field])).length;
  const status = filled === 0 ? 'empty' : filled === total ? 'full' : 'partial';
  return { filled, total, status };
}

// edu_level: { title_uz, title_ru, title_en } → "Bakalavr"
export const eduLevelTitle = (value) =>
  value && typeof value === 'object' ? value.title_uz || value.title_ru || value.title_en || null : value || null;
